/*
 * @Author: Wei Guojun 
 * @Date: 2022-06-21 17:26:53 
 * @Last Modified by: Wei Guojun
 * @Last Modified time: 2022-08-24 11:14:45
 */

<template>
    <div>
        <projectHeader></projectHeader>
        <div class="top"></div>
        <div class="center">
            <div class="left"></div>
            <div class="aside">
                <div class="goback" @click="goBack"><img src="../assets/images/goback.png"/><span>返回</span></div>
                <div class="title">绑定快递员</div>
                <div class="bindItem">
                    <h4>方式一：扫码绑定</h4>
                    <div class="color8">通过微信扫描快递员的“协议客户码”申请绑定；</div>
                </div>
                <div class="bindItem">
                    <h4>方式二：添加快递员手机号码+姓名，极速绑定</h4>
                    <div class="color8">通过添加快递员手机号和姓名可提交绑定，需快递员审核；</div>
                    <div><el-button type="primary" size="small" @click="openP_N">手机号+姓名</el-button></div>
                </div>
                <div class="bindItem">
                    <h4>方式三：添加快递员手机号+验证码，免审核绑定</h4>
                    <div class="color8">通过添加快递员的手机号和验证码添加绑定，无需快递员审核；</div>
                    <div><el-button type="primary" size="small" @click="openP_C">手机号+验证码</el-button></div>
                </div>
            </div>
            <div class="right"></div>
        </div>
        <!-- 手机号和姓名绑定弹窗 -->
        <el-dialog title="手机号+姓名绑定" :visible.sync="pnshow" class="myDialog" width="600px">
            <el-form :model="phoneAndname" label-width="110px" :label-position="labelPosition" :rules="pnrules" ref="pnForm" size="small">
                <h4>添加快递员手机号码+姓名，极速绑定</h4>
                <div class="color8">通过添加快递员手机号和姓名可提交绑定，需快递员审核;默认每日可使用10单，如需更多请联系快递员调整每日限额；</div>
                <el-form-item label="快递员姓名" prop="ywy_name">
                  <el-input v-model="phoneAndname.ywy_name" placeholder="快递员姓名不超过10个字"></el-input>
                </el-form-item>
                <el-form-item label="快递员手机号" prop="ywy_phone">
                  <el-input v-model="phoneAndname.ywy_phone" placeholder="请输入快递员手机号"></el-input>
                </el-form-item>                
                 <el-form-item label="您的商家名" prop="user_name">
                  <el-input v-model="phoneAndname.user_name" placeholder="商家名不超过10个字"></el-input>
                </el-form-item>     
                 <el-form-item label="您的手机号" prop="user_phone" required>
                  <el-input v-model="phoneAndname.user_phone" placeholder="请输入您的手机号"></el-input>
                </el-form-item>
                <el-form-item label="验证码" prop="valid_code">
                  <el-input v-model="phoneAndname.valid_code" placeholder="请输入验证码">
                     <el-button v-show ="!codeShow2" slot="append" @click="getuser_Code('phoneAndname')">获取验证码</el-button>
                     <el-button v-show ="codeShow2" slot="append">{{codeNum2}}</el-button>
                  </el-input>
                </el-form-item>
                 <el-form-item label="商家所在地" prop="address">
                  <el-input v-model="phoneAndname.address" placeholder="请输入您的商家所在地"></el-input>
                </el-form-item>
                <el-form-item prop="server">
                  <el-checkbox-group v-model="phoneAndname.server">
                    <el-checkbox label="" name="server" class="server">我已阅读并同意<span @click="drawOpen(1)">《韵达快递服务条款》</span>和<span @click="drawOpen(2)">《隐私政策》</span></el-checkbox> 
                  </el-checkbox-group>
                </el-form-item>           
                <div class="flexBox">
                  <el-button type="primary" @click="onSubmit">提交绑定</el-button>
                </div>
            </el-form>
        </el-dialog>   
        <!-- 手机号和验证码绑定弹窗 -->
        <el-dialog title="手机号+验证码绑定" :visible.sync="pcshow" class="myDialog" width="600px">
            <el-form v-if="steps== 'one'" :model="phoneAndcodefirst" label-width="110px" :label-position="labelPosition" :rules="pcrules" ref="pcForm" size="small">
                <h4>添加快递员手机号码+验证码，免审核绑定</h4>
                <div class="color8">通过添加快递员手机号和验证码添加绑定，无需快递员审核;默认每日可使用50单，如需更多请联系快递员调整每日限额；</div>
                <el-form-item label="您的商家名" prop="user_name">
                  <el-input v-model="phoneAndcodefirst.user_name" placeholder="商家名不超过10个字"></el-input>
                </el-form-item> 
                 <el-form-item label="您的手机号" prop="user_phone" required>
                  <el-input v-model="phoneAndcodefirst.user_phone" placeholder="请输入您的手机号"></el-input>
                </el-form-item>
                <el-form-item label="验证码" prop="valid_code">
                  <el-input v-model="phoneAndcodefirst.valid_code" placeholder="请输入验证码">
                     <el-button v-show ="!codeShow2" slot="append" @click="getuser_Code('phoneAndcodefirst')">获取验证码</el-button>
                     <el-button v-show ="codeShow2" slot="append">{{codeNum2}}</el-button>
                  </el-input>
                </el-form-item>
                 <el-form-item label="商家所在地" prop="address">
                  <el-input v-model="phoneAndcodefirst.address" placeholder="请输入您的商家所在地"></el-input>
                </el-form-item>                    
                <div class="flexBox">
                  <el-button type="primary" @click="oncodeSubmitfist">下一步</el-button>
                </div>
            </el-form>
            <el-form v-if="steps== 'two'" :model="phoneAndcodetwo" label-width="130px" :label-position="labelPosition" :rules="pcrules2" ref="pcForm2" size="small">
                <h4>添加快递员手机号码+验证码，免审核绑定</h4>
                <div class="color8">通过添加快递员手机号和验证码添加绑定，无需快递员审核;默认每日可使用50单，如需更多请联系快递员调整每日限额；</div>
                <el-form-item label="快递员手机" prop="ywy_phone">
                  <el-input v-model="phoneAndcodetwo.ywy_phone" placeholder="请输入快递员手机号"></el-input>
                </el-form-item>
                <el-form-item label="快递员短信验证码" prop="sms_code">
                  <el-input v-model="phoneAndcodetwo.sms_code" placeholder="请输入验证码">
                     <el-button v-show ="!codeShow" slot="append" @click="getCode">获取验证码</el-button>
                     <el-button v-show ="codeShow" slot="append">{{codeNum}}</el-button>
                  </el-input>
                </el-form-item>    
                <el-form-item prop="server">
                  <el-checkbox-group v-model="phoneAndcodetwo.server">
                    <el-checkbox label="" name="server" class="server">我已阅读并同意<span @click="drawOpen(1)">《韵达快递服务条款》</span>和<span @click="drawOpen(2)">《隐私政策》</span></el-checkbox> 
                  </el-checkbox-group>
                </el-form-item>          
                <div class="flexBox">
                  <el-button type="primary" @click="oncodeSubmit">提交绑定</el-button>
                </div>
            </el-form>
        </el-dialog> 
        <el-drawer
          :title="drawerTitle"
          :visible.sync="drawer"
          direction="rtl"
          :before-close="handleClose">
          <severItem v-if="componentIndex == 1"></severItem>
          <privacy v-else></privacy>
        </el-drawer>
    </div>
</template>
<script>
import privacy from "@/components/privacy";
import severItem from "@/components/severItem";
import projectHeader from "@/components/header";
import bindKdy from "@/api/bindKdy";
import home from "@/api/home";
var codeInterval
var codeInterval2
export default {
    name:'bindywy',
    data(){
        var checkPhone = (rule, value, callback) => {
            if (!value) {
            return callback(new Error('请输入快递员手机号'));
            }
            var phonetest = /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-7|8|9])|(?:5[0-3|5-9])|(?:6[2|5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1|3|5|8|9]))\d{8}$/;
            setTimeout(() => {
            if (!phonetest.test(value)) {
                callback(new Error('快递员手机号格式错误'));
            } else {
                callback();
            }
            }, 1000);
        };
        var checkPhone2 = (rule, value, callback) => {
            if (!value) {
            return callback(new Error('请输入您的手机号'));
            }
            var phonetest = /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-7|8|9])|(?:5[0-3|5-9])|(?:6[2|5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1|3|5|8|9]))\d{8}$/;
            setTimeout(() => {
            if (!phonetest.test(value)) {
                callback(new Error('您的手机号格式错误'));
            } else {
                callback();
            }
            }, 1000);
        };
        return{
          bindkdyInfo:'',
          pnshow:false,
          pcshow:false,
          labelPosition:'left',
          phoneAndname:{
            user_name:'',
            ywy_name:'',
            ywy_phone:'',
            user_phone:'',
            valid_code:'',
            address:"",
            server:[],
            mail_num_limit:10,
          },
          phoneAndcodefirst:{
            user_name:'',  
            user_phone:'',
            valid_code:'',
            address:"",
          },
          phoneAndcodetwo:{
            ywy_phone:'',
            sms_code:'', 
            server:[],
            mail_num_limit:50,   
          },
          pnrules:{
            user_name: [
                { required: true, message: '请输入商家名称', trigger: 'blur' },
                { min: 1, max: 10, message: '商家名称长度应在 1 到 10 个字符', trigger: 'blur' }
            ],
            ywy_name: [
                { required: true, message: '请输入快递员姓名', trigger: 'blur' },
                { min: 1, max: 10, message: '快递员姓名应在 1 到 10 个字符', trigger: 'blur' }
            ],
            valid_code:[{ required: true, message: '请输入您的手机短信验证码', trigger: 'blur' }],
            ywy_phone:[{required: true, validator: checkPhone, trigger: 'blur'}],
            user_phone:[{required: true, validator: checkPhone2, trigger: 'blur'}],
            server:[{type: 'array', required: true, message: '请同意并勾选韵达快递服务条款和隐私政策', trigger: 'change' }]
          },
          pcrules:{
            user_name: [
                { required: true, message: '请输入商家名称', trigger: 'blur' },
                { min: 1, max: 10, message: '商家名称长度应在 1 到 10 个字符', trigger: 'blur' }
            ],
            user_phone:[{required: true, validator: checkPhone2, trigger: 'blur'}],
            valid_code:[{ required: true, message: '请输入您的手机短信验证码', trigger: 'blur' }],
          },
          pcrules2:{
            ywy_phone:[{required: true, validator: checkPhone, trigger: 'blur'}],
            sms_code: [
                { required: true, message: '请输入验证码', trigger: 'blur' },
            ],
            server:[{type: 'array', required: true, message: '请同意并勾选韵达快递服务条款和隐私政策', trigger: 'change' }]
          },
          codeShow:false,
          codeNum:'60s',
          codeShow2:false,
          codeNum2:'60s',
          steps:'one',
          drawer: false,
          pnchecked:false,
          componentIndex:1,
          drawerTitle:'',
        }
    },
    components: { projectHeader,severItem,privacy },
    methods:{
        drawOpen(index){
          this.componentIndex = index;
          if(index == 1){
            this.drawerTitle = '韵达快递服务条款'
          }else{
            this.drawerTitle = '隐私政策'         
          }
          this.drawer = true
        },
        handleClose(done){
         done() 
        },
        openP_N(){
          this.pnshow = true;
        },
        openP_C(){
          this.pcshow = true;  
        },
        onSubmit(){
          this.$refs.pnForm.validate((valid) => {
            if (valid) {
               const query = {...this.phoneAndname} 
               bindKdy.bindingYwyByName(this,query).then(res=>{
                if(res.success){
                    this.$message.success('绑定成功,请联系快递员极速审核');
                    this.hasbind()
                }
               })
            } else {
                console.log('error submit!!');
                return false;
            }
          });
        },
        oncodeSubmitfist(){
          this.$refs.pcForm.validate((valid) => {
            if (valid) {
               const query = {...this.phoneAndcodefirst} 
               bindKdy.bindingYwyBySmsCodeAccount(this,query).then(res=>{
                if(res.success){
                    this.$message.success('认证成功')
                    this.steps = 'two'
                }
               })
            } else {
                console.log('error submit!!');
                return false;
            }
          }); 
        },
        oncodeSubmit(){
          this.$refs.pcForm2.validate((valid) => {
            if (valid) {
               const query = {...this.phoneAndcodetwo} 
               bindKdy.bindingYwyBySmsCode(this,query).then(res=>{
                if(res.success){
                    this.$message.success('绑定成功')
                    this.hasbind()
                }
               })
            } else {
                console.log('error submit!!');
                return false;
            }
          }); 
        },
        //获取手机验证码
        getCode(){
            var phonetest = /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-7|8|9])|(?:5[0-3|5-9])|(?:6[2|5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1|3|5|8|9]))\d{8}$/;
            if(this.phoneAndcodetwo.ywy_phone == '' || !phonetest.test(this.phoneAndcodetwo.ywy_phone)){
            this.$message.error('快递员联系方式有错或未填写');
             return
            }
            this.codeShow = true
            let second = 60;
            this.getCodeFun();
            codeInterval = setInterval(()=>{
            second --
            console.log(second,'second');
            if(second < 0){
                this.codeNum = 60;
                this.codeShow = false
                clearInterval(codeInterval);
            }else{
                this.codeNum = second + 's'
            } 
            },1000)
        },
        getCodeFun(){
            const query = {
            "user_name":this.phoneAndcodefirst.user_name,
            "ywy_phone":this.phoneAndcodetwo.ywy_phone
            }
            bindKdy.sendBindingSmsCode(this,query).then(res=>{
            if (res.success) {
                this.$message.success('短信已发送，请耐心等待')
            } else {
                this.$message.error(res.body.message)
            }
        })
        },
        //获取商家手机验证码
        getuser_Code(type){
          debugger
            var phonetest = /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-7|8|9])|(?:5[0-3|5-9])|(?:6[2|5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1|3|5|8|9]))\d{8}$/;
            if(this[type].user_phone == '' || !phonetest.test(this[type].user_phone)){
            this.$message.error('您的联系方式有错或未填写');
             return
            }
            this.codeShow2 = true
            let second = 60;
            this.getuserCodeFun(this[type].user_phone);
            codeInterval2 = setInterval(()=>{
            second --
            console.log(second,'second');
            if(second < 0){
                this.codeNum2 = 60;
                this.codeShow2 = false
                clearInterval(codeInterval2);
            }else{
                this.codeNum2 = second + 's'
            } 
            },1000)
        },
        getuserCodeFun(phone){
            bindKdy.sendmobilemsg(this,phone).then(res=>{
            if (res.success) {
                this.$message.success('短信已发送，请耐心等待')
            } else {
                this.$message.error(res.body.message)
            }
        })
        },
        //判断是否绑定快递员
        hasbind(){
          home.hasbind(this).then((res) => {
            this.bindkdyInfo = res.data
            this.$store.commit("SET_BIND_KDY", res.data);
            if (this.bindkdyInfo == 0) {
            this.$alert('您的绑定关系正在审核中，暂时无法正常使用打印功能,请联系对口快递员审核绑定关系。', '提示', {
              confirmButtonText: '我知道了',
              callback: action => {}});
            } else if (this.bindkdyInfo == 99) {
            this.$alert('您还未添加电子面单账号，无法正常使用下单功能，请添加网点电子面单账号或绑定协议快递员。', '提示', {
              confirmButtonText: '我知道了',
              callback: action => {}});
            } else {
            }
            this.goBack();
          });
        },
        goBack(){
           this.$router.push({path:'./home'})
        },
    }
  
  
}
</script>
<style lang="stylus" scoped>
.top{width:100%; height:60px; background:#f5f5f5; position:absolute; top:0; left:0;}
.center{width:100%; background:#f5f5f5; position:absolute; top:60px; bottom:0;}
.left{width:20%; height:100%; background:#f5f5f5;; float:left; }
.right{overflow:hidden; height:100%;width:20%;float:left;}
.aside{width:60%; height:100%; background:#fff; float:left;min-with:1000px;border-radius: 8px;font-size:14px}
.title{
  margin: 0 100px;  
  font-size: 16px;
  font-weight: bold;
  line-height: 50px;
  border-bottom: 1px solid #f5f5f5;
}
.goback{
    margin: 20px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-content: center;
    line-height:30px;
    width: 100px;
    cursor pointer
    img{
        width: 30px;
        height: 30px;
    }
    span{
        margin-left: 10px;
        color: #888888;
    }
}
.bindItem{
    padding: 0 100px;
    line-height:30px;
    margin-top: 20px;

}    
.color8{
    color: #888888;
    font-size: 12px;
    margin-bottom: 10px;
}
.myDialog{
    font-size: 14px;
    line-height: 30px;
    /deep/ .el-form-item__label{
        line-height: 36px;
        font-size: 13px
    }
}
.myDialog >>> .el-dialog__body{
    padding: 0px 20px 10px 20px;

}
.flexBox{
    display: flex;
    justify-content: center;
}
.server span{
  color #66b1ff;
}
</style>